export const LOCIZE_SAVE_MISSING = false

export const LOCIZE_API_KEY = ''

export const LOCIZE_ALLOWED_HOST = ''
